const anchors = [...document.querySelectorAll('.js-aanpak-block')];
const pointers = [...document.querySelectorAll('.js-aanpak-anchor')];

const events = () => {
  pointers.forEach((pointer, idx) => pointer.addEventListener('click', () => window.scrollTo({
    top: anchors[idx].getBoundingClientRect().y - 136, // padding 136px
    behavior: 'smooth',
  })));
};

const init = () => {
  if (anchors.length) {
    events();
  }
};

export default {
  init,
};
